export default "__VITE_ASSET__d276a3f3__"